'use strict';

import Inscripcion from './inscripcion/inscripcion.emp.module';
import Matricula from './matricula/matricula.emp.module';
import Registro from './registro/registro.emp.module';
import Formulario from './formulario/formulario.emp.module';
import Certificado from './certificado/certificado.emp.module';
import Bandeja from './bandeja/bandeja.module';
import Duplicar from './duplicar/duplicar.module';
import BandejaAguinaldo from './bandeja/bandeja.aguinaldo.module';
import BandejaRefrigerio from './bandeja/bandeja.refrigerio.module';


const Empresario = angular
    .module('app.empresario', [
        Inscripcion,
        Registro,
        Matricula,
        Formulario,
        Certificado,
        Bandeja,
        Duplicar,
        BandejaAguinaldo,
        BandejaRefrigerio,
        
    ])
    .name;

export default Empresario;



// WEBPACK FOOTER //
// ./src/app/components/probolivia/empresario/empresario.module.js